const ACTION = {
    UPDATE_CERT_PHOTO_ONE: 'UPDATE_CERT_PHOTO_ONE',
    UPDATE_CERT_PHOTO_ONE_PREVIEW_URL: 'UPDATE_CERT_PHOTO_ONE_PREVIEW_URL',
    UPDATE_CERT_PHOTO_TWO: 'UPDATE_CERT_PHOTO_TWO',
    UPDATE_CERT_PHOTO_TWO_PREVIEW_URL: 'UPDATE_CERT_PHOTO_TWO_PREVIEW_URL',
    UPDATE_ERROR_TEXT_ONE: 'UPDATE_ERROR_TEXT_ONE',
    UPDATE_ERROR_TEXT_TWO: 'UPDATE_ERROR_TEXT_TWP'
}

export default ACTION;